export default "__VITE_ASSET__Dtyu5wI2__"